var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fam-address-list mt-md"},[_c('el-card',{staticClass:"mb-md",attrs:{"shadow":"never"}},[_c('f-god-address-picker',{attrs:{"radio":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }